import type { RiskItem } from './safeJournalApi';

/**
 * 위험성평가 · TBM 일지(V572 · DOC-136)의 표 한 장에 함께 쓰는 조각 — 제목 줄과 결재란, 칸 이름표.
 * 결재란은 일지 종이와 같은 규격(서명 칸 30px · 이름표 배경 통일)이고 칸은 안전관리자 · 현장소장이다(서버 signersOf 와 같다).
 */
export const SHEET_SIGNERS = ['안전관리자', '현장소장'];


/** 평가 구분 — 최초 · 정기 · 수시(산업안전보건법 시행규칙 제37조 · 고시 제15조). 값은 일지의 title 에 담는다. */
export const RISK_KINDS = ['최초', '정기', '수시'];

export function blankRiskItem(from?: Partial<RiskItem>): RiskItem {
  return {
    vendorName: from?.vendorName ?? null,
    workType: from?.workType ?? null,
    task: from?.task ?? null,
    hazard: '',
    likelihood: null,
    severity: null,
    measure: null,
    owner: null,
    dueDate: null,
    keyPoint: false,
  };
}

/** 표 칸 안의 입력 — 평소엔 표의 글처럼 보이고 누르면 테두리가 선다(종이 양식과 같은 결). */
export const SHEET_STYLES = `
.ss-sheet { background: #fff; border: 1px solid var(--border); border-radius: 10px; padding: 22px 24px; min-width: 860px; }
.ss-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 16px; }
.ss-head h2 { font-size: 22px; font-weight: 800; letter-spacing: 0.08em; margin: 6px 0 0; }
.ss-sign { border-collapse: collapse; font-size: 12px; }
.ss-sign th, .ss-sign td { border: 0.6pt solid #444; text-align: center; vertical-align: middle; padding: 2px 6px; }
.ss-sign th { background: #f1f1f1; font-weight: 500; min-width: 84px; }
.ss-sign td { height: 30px; }
.ss-sign .ss-sign-side { min-width: 0; width: 22px; line-height: 1.3; }
.ss-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px 16px; margin-bottom: 18px; }
.ss-field { display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: var(--text-secondary); }
.ss-field.ss-wide { grid-column: 1 / -1; }
.ss-section { display: flex; align-items: center; justify-content: space-between; margin: 18px 0 8px; font-size: 14px; font-weight: 700; }
.ss-grid { width: 100%; border-collapse: collapse; font-size: 12.5px; table-layout: fixed; }
.ss-grid th { background: #f8fafc; color: var(--text-secondary); font-weight: 600; padding: 7px 6px; border: 1px solid var(--border); white-space: nowrap; }
.ss-grid td { border: 1px solid var(--border); padding: 0; vertical-align: middle; }
.ss-grid td.ss-c { text-align: center; padding: 0 4px; }
.ss-cell { width: 100%; border: 1px solid transparent; background: transparent; padding: 6px; font: inherit; color: inherit; outline: none; resize: none; }
.ss-cell:hover { background: #f8fafc; }
.ss-cell:focus { border-color: var(--accent-light); background: #fff; box-shadow: 0 0 0 2px rgba(59,130,246,0.12); }
.ss-x { background: none; border: none; color: var(--text-muted); cursor: pointer; font-size: 15px; padding: 4px 8px; }
.ss-x:hover { color: var(--danger); }
.ss-chip { display: inline-flex; align-items: center; gap: 6px; padding: 5px 10px; border-radius: 999px; border: 1px solid var(--border); background: #fff; font-size: 12.5px; cursor: pointer; }
.ss-chip.on { border-color: var(--accent); background: var(--accent-bg); color: var(--accent); font-weight: 600; }
.ss-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.ss-empty { color: var(--text-muted); font-size: 12.5px; padding: 10px 0; }
`;
